export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  {
    slug: "image-text",
    name: "图文素材",
    description: "高质量的原创图文内容资源，涵盖生活方式、科技评测、文化评论、旅行游记等多个领域的精华文章与配图素材",
    icon: "ri-file-text-line",
    count: 3256
  },
  {
    slug: "video",
    name: "原创视频",
    description: "专业制作的原创视频素材库，包含航拍风光、城市延时、产品展示、人物访谈等多种风格的视频内容资源",
    icon: "ri-video-line",
    count: 1842
  },
  {
    slug: "creative",
    name: "创意素材",
    description: "汇集插画、图标、矢量图形、3D模型等多元创意素材，为设计和内容创作提供丰富的灵感与参考资源",
    icon: "ri-lightbulb-line",
    count: 4521
  },
  {
    slug: "template",
    name: "设计模板",
    description: "专业的可编辑设计模板库，提供海报、Banner、社交媒体封面、PPT模板等各类设计源文件，支持个性化定制",
    icon: "ri-layout-line",
    count: 2187
  }
];

export const getCategoryBySlug = (slug: string): Category | undefined => {
  return categories.find(cat => cat.slug === slug);
};